import classNames from 'classnames';
import * as React from 'react';
import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-css-effects/scale.css';

import { Bem } from '../../service/Bem/Bem';
import { Shape2, Shape2Icon, Shape2Tone } from '../Shape2/Shape2';

import './Notice.css';

export interface NoticeIcon {
    name: Shape2Icon.tick | Shape2Icon.warning;
    size: number;
}

export interface AlertContentTemplateProps {
    classNames: string;
    id: string;
    styles: React.CSSProperties;
    message: string;
    handleClose: () => void;
    customFields?: {
        icon?: NoticeIcon;
        button?: React.ReactNode;
    };
}

const BLOCK = 'notice';

class NoticeTemplate extends React.Component<AlertContentTemplateProps> {
    render() {
        const { customFields, id, styles, handleClose, message } = this.props;

        let icon, iconElement;
        const button = customFields ? customFields.button : null;

        if (customFields && customFields.icon) {
            icon = customFields.icon;

            iconElement = (
                <Shape2
                    icon={icon.name}
                    cls={Bem.cls(BLOCK, 'icon')}
                    width={icon.size}
                    height={icon.size}
                    tone={Shape2Tone.white}
                />
            );
        }

        return (
            <div
                className={classNames(
                    this.props.classNames,
                    Bem.cls({
                        block: BLOCK,
                        mods: { 'with-button': Boolean(button) }
                    })
                )}
                id={id}
                style={styles}
            >
                {iconElement}

                <div className={Bem.cls(BLOCK, 'content')}>
                    <span className={Bem.cls(BLOCK, 'message')}>{message}</span>
                    {button && (
                        <div className={Bem.cls(BLOCK, 'button')}>{button}</div>
                    )}
                </div>

                <span
                    className={Bem.cls(BLOCK, 'close')}
                    onClick={handleClose}
                />
            </div>
        );
    }
}

export interface NoticeProps {
    timeout?: 'none' | number;
    stack?: boolean | { limit?: number; spacing?: number };
}

export class Notice extends React.Component<NoticeProps, {}> {
    render() {
        const { timeout = 10000, stack = { limit: 3 } } = this.props;

        return (
            <Alert
                stack={stack}
                position={'bottom-right'}
                effect={'scale'}
                timeout={timeout}
                contentTemplate={NoticeTemplate}
            />
        );
    }
}
